import { useQueries, useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import useOrderService from "../../services/api/orderService";
import useItemService from "../../services/api/itemService";
import { enums } from "../../constants/enum";

import { Loading, PageTitle, SmsGatewayStatus } from "../../components";
import { UserCircleIcon } from "../../assets/icons";
import "./DashboardPage.scss";

function DashboardPage() {
  const { queryKey: orderQueryKey, getOrdersStatistics } = useOrderService();
  const { queryKey: itemQueryKey, getItemStatistics } = useItemService();

  const [ordersQuery, itemsQuery] = useQueries({
    queries: [
      {
        queryKey: [orderQueryKey],
        queryFn: getOrdersStatistics,
      },
      {
        queryKey: [itemQueryKey],
        queryFn: getItemStatistics,
      },
    ],
  });

  const isLoading = ordersQuery.isLoading || itemsQuery.isLoading;
  const isError = ordersQuery.isError || itemsQuery.isError;
  const error = ordersQuery.error || itemsQuery.error;

  const ordersStatistics = ordersQuery.data;
  const itemsStatistics = itemsQuery.data;

  if (isLoading) {
    return <Loading variant="fullScreen" />;
  }

  if (isError) {
    toast.error(
      error?.response?.data?.payload?.message || enums.DEFAULT_ERROR_MESSAGE,
    );
  }
  const findRelevantStatistics = (orderStatus) => {
    return ordersStatistics?.statistics?.statusWise?.find(
      (stat) => stat._id === orderStatus,
    );
  };
  return (
    <div className="page dashboard-page">
      <PageTitle text="Dashboard" />

      <div className="dashboard-grid">
        <div className="row">
          <div className="card order-counts-card">
            <h3>Order Counts</h3>
            <div className="stat-row">
              <div className="stat-item">
                <span className="count">
                  {findRelevantStatistics(enums.ORDER_STATUSES.CONFIRMED)
                    ?.count || 0}
                </span>
                <span className="badge warning">Confirmed</span>
              </div>
              <div className="stat-item">
                <span className="count">
                  {findRelevantStatistics(enums.ORDER_STATUSES.READY)?.count ||
                    0}
                </span>
                <span className="badge info">Ready</span>
              </div>
              <div className="stat-item">
                <span className="count">
                  {findRelevantStatistics(enums.ORDER_STATUSES.COMPLETED)
                    ?.count || 0}
                </span>
                <span className="badge success">Completed</span>
              </div>
              <div className="stat-item">
                <span className="count">
                  {ordersStatistics?.statistics?.totalOrders || 0}
                </span>
                <span className="badge default">Total</span>
              </div>
            </div>
          </div>

          <div className="card sms-gateway-card">
            <h3>SMS Gateway</h3>
            <div className="gateway-content">
              <SmsGatewayStatus />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="card user-count-card">
            <div className="user-count-wrapper">
              <div className="icon-circle">
                <UserCircleIcon />
              </div>
              <div className="user-info">
                <span className="label">User Count</span>
                <span className="count">01</span>
              </div>
            </div>
          </div>

          <div className="card item-count-card">
            <h3>Item Count</h3>
            <div className="stat-row">
              <div className="stat-item">
                <span className="count">{itemsStatistics?.frames || 0}</span>
                <span className="badge frame">{enums.ITEM_CATEGORIES.FRAME}</span>
              </div>
              <div className="stat-item">
                <span className="count">{itemsStatistics?.lenses || 0}</span>
                <span className="badge lense">{enums.ITEM_CATEGORIES.LENSE}</span>
              </div>
              <div className="stat-item">
                <span className="count">{itemsStatistics?.accessories || 0}</span>
                <span className="badge accessory">{enums.ITEM_CATEGORIES.ACCESSORIES}</span>
              </div>
              <div className="stat-item">
                <span className="count">{itemsStatistics?.sunglasses || 0}</span>
                <span className="badge sunglass">{enums.ITEM_CATEGORIES.SUNGLASS}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DashboardPage;
